import gql from "graphql-tag";
import {client} from "./client";
import {DeleteEntityByFullUid} from "../../schema/DeleteEntityByFulluid";
import {deleteEntitygeometryByFullUid} from "./deleteEntitygeometryByFullUid";
import {FetchResult, Mutation} from "../../types";

const getEntityMutation = (fullUid: string): any => ({
    mutation: gql`${DeleteEntityByFullUid}`,
    variables: {
        fullUid,
    }
});

export async function deleteEntityByFullUid (fullUid: string) {
    const entityGeometry = await deleteEntitygeometryByFullUid(fullUid);
    const entityResult: FetchResult<Mutation> = await client.mutate(getEntityMutation(fullUid));
    const entity = entityResult?.data?.deleteEntityByFullUid?.entity;
    if (!entityGeometry) {
        throw new Error('entity geometry does not exist');
    } else if (!entity) {
        throw new Error('entity does not exist');
    } else {
        await client.cache.reset();
        return entity;
    }
}
